import { createSelector } from 'reselect';
import { getEntities } from '../../../Resources/EntityData.js';
import { calendlyLinkSchema, CALENDLY_LINK } from '../../../Schema/CalendlyLinkSchema.js';
import { passwordBannerDisplayStateSchema } from 'schema/PasswordBannerDisplayStateSchema.js';
import { productTourStateSchema } from 'schema/ProductTourStateSchema.js';
import SetupApi from './SetupApi.js';

export const getFormSubmitting = createSelector(
  (state) => state.formSubmitting,
  (formSubmitting) => {
    return formSubmitting || false;
  }
);

export const getHistory = (state) => state.sessionHistory || [];
export const getErrorText = (state) => state.errorText || '';

export const getPassword = createSelector(
  (state) => state.proPassword,
  (proPassword) => {
    return proPassword || {};
  }
);

export const isPasswordBlank = createSelector(getPassword, (proPassword) => {
  return proPassword.password;
});

export const isSalesAssistedSignup = createSelector(getPassword, (proPassword) => {
  return proPassword.sales_assisted_signup;
});

export const getCalendlyLink = createSelector(getEntities, (entities) => {
  return entities?.[CALENDLY_LINK]?.data?.link || '';
});

export const fetchProPassword = {
  fetchingApiFunc: SetupApi.fetchIsPasswordBlank,
  selector: getPassword,
  paramsFromProps: () => [],
  dataNamespace: 'proPassword',
};

export const fetchCalendlyLink = {
  fetchingApiFunc: SetupApi.fetchCalendlyLink,
  selector: getCalendlyLink,
  paramsFromProps: () => [],
  schema: calendlyLinkSchema,
};

export const getPasswordBannerState = createSelector(getEntities, (entities) => {
  return entities?.password_banner?.data?.display || false;
});

export const fetchPasswordBannerState = {
  fetchingApiFunc: SetupApi.fetchPasswordBannerState,
  selector: getPasswordBannerState,
  paramsFromProps: () => [],
  schema: passwordBannerDisplayStateSchema,
  alwaysFetch: true,
};

export const shouldSeeProductTour = createSelector(getEntities, (entities) => {
  return entities?.product_tour?.data?.should_see_product_tour || false;
})

export const fetchShouldSeeProductTour = {
  fetchingApiFunc: SetupApi.fetchProductTourState,
  selector: shouldSeeProductTour,
  paramsFromProps: () => [],
  schema: productTourStateSchema,
  alwaysFetch: true,
}